import { isQuotingToolAvailable, isSupplier } from 'modules/common/permissions';

import AccountingChunk from './accounting/entry';
import { initSaga as accountingInitSaga } from './accounting/index';
import CompanyChunk from './company/entry';
import { initSaga as companyInitSaga } from './company/index';
import DigitalQuoteChunk from './digitalQuote/entry';
import { initSaga as digitalQuoteInitSaga } from './digitalQuote/index';
import IntegrationsChunk from './integrations/entry';
import { initSaga as integrationsInitSaga } from './integrations/index';
import IntegrationDetailsChunk from './integrations/integrationDetailsPage/entry';
import {
  isAccountingAccessible,
  isCompanySettingsAccessible,
  isDigiQuoteSettingsAccessible,
  isIntegrationsSettingsAccessible,
  isIntegrationsDetailPageAccessible,
} from './permissions';
import QuoteCreationChunk from './quoteCreation/entry';
import { initSaga as smartRfqInitSaga } from './quoteCreation/index';
import UserProfileChunk from './userProfile/entry';
import { initSaga as userProfileInitSaga } from './userProfile/index';

export default [
  {
    component: AccountingChunk,
    exact: true,
    name: 'settingsAccounting',
    path: '/settings/accounting/:subPageId',
    permissions: [isSupplier, isAccountingAccessible],
    saga: accountingInitSaga,
  },
  {
    component: CompanyChunk,
    exact: true,
    name: 'settingsCompany',
    path: '/settings/company/:subPageId',
    permissions: [isSupplier, isCompanySettingsAccessible],
    saga: companyInitSaga,
  },
  {
    component: DigitalQuoteChunk,
    exact: true,
    name: 'settingsDigitalQuote',
    path: '/settings/digital_quote/:subPageId',
    permissions: [isQuotingToolAvailable, isDigiQuoteSettingsAccessible],
    saga: digitalQuoteInitSaga,
  },
  {
    component: IntegrationsChunk,
    exact: true,
    name: 'settingsIntegrations',
    path: '/settings/integrations/:subPageId/:resourceId?',
    permissions: [isQuotingToolAvailable, isIntegrationsSettingsAccessible],
    saga: integrationsInitSaga,
  },
  {
    component: IntegrationDetailsChunk,
    exact: true,
    name: 'integrationDetails',
    path: '/settings/integration_details/:managedIntegrationUuid',
    permissions: [isQuotingToolAvailable, isIntegrationsDetailPageAccessible],
  },
  {
    component: UserProfileChunk,
    exact: true,
    name: 'UserProfileChunk',
    path: '/settings/profile/:subPageId',
    permissions: [isSupplier],
    saga: userProfileInitSaga,
  },
  {
    component: QuoteCreationChunk,
    exact: true,
    name: 'settingsQuoteCreation',
    path: '/settings/quote_creation/:subPageId',
    permissions: [isQuotingToolAvailable, isCompanySettingsAccessible],
    saga: smartRfqInitSaga,
  },
];
